import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import CardConvidados from './CardConvidados';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import MinistraMaria from '../images/Ministra-M.jpg';
import MinistraNisia from '../images/Ministra-N.jpg';
import { Navigation } from 'swiper/modules';

const CarrosselConvidados = () => {

  const slidesScreen = [1, 5];

  function getSlidesPerView() {
    const screenWidth = window.innerWidth;

    if (screenWidth < 600) {
      return slidesScreen[0];
    } else {
      return slidesScreen[1];
    }
  }
  return (

    <>
      <Swiper
        slidesPerView={getSlidesPerView()}
        spaceBetween={30}
        centeredSlides={false}
        navigation={true}
        modules={[Navigation]}
        className="mySwiper"
      >

        <SwiperSlide>
          <CardConvidados
            image="https://www.cartacapital.com.br/wp-content/uploads/2023/06/reuniao-arcabouco-fiscal_mcamgo_abr_23052023-16.jpg"
            title="Arthur Lira"
            nome="Arthur Lira"
            cargo="Presidente da Câmara"
          />
        </SwiperSlide>

        <SwiperSlide>
          <CardConvidados
            image="https://s2-g1.glbimg.com/3MZbAXoWF-TdTYSpeWzkvZCCKNM=/0x0:567x557/984x0/smart/filters:strip_icc()/i.s3.glbimg.com/v1/AUTH_59edd422c0c84a879bd37670ae4f538a/internal_photos/bs/2022/8/w/czuhcNQBiZDw0ANEKNig/ba200449a303-vinicius-marques-de-carvalho-2.jpg"
            title="Vinicius Marques de Carvalho"
            nome="Vinicius Marques de Carvalho"
            cargo="Ministro da CGU"
          />
        </SwiperSlide>

        <SwiperSlide>
          <CardConvidados
            image="https://static.poder360.com.br/2023/02/Lula-foto-oficial-recortada-reduzida-848x477.jpg"
            title="Luiz Inácio Lula da Silva"
            nome="Luiz Inácio Lula da Silva"
            cargo="Presidente da República"
          />
        </SwiperSlide>

        <SwiperSlide>
          <CardConvidados
            image="https://www.cnnbrasil.com.br/wp-content/uploads/sites/12/2023/02/luis_roberto_barroso_stf_05.jpg?w=1200&h=1200&crop=1"
            title="Ministro Barroso"
            nome="Luis Roberto Barroso"
            cargo="Presidente e Ministro do Supremo Tribunal Federal"
          />
        </SwiperSlide>

        <SwiperSlide>
          <CardConvidados
            image="https://www.senado.gov.br/senadores/img/fotos-oficiais/senador5732.jpg"
            title="Rodrigo Pacheco"
            nome="Rodrigo Pacheco"
            cargo="Presidente do Senado"
          />
        </SwiperSlide>

        <SwiperSlide>
          <CardConvidados
            image={MinistraNisia}
            title="Nísia Verônica Trindade Lima"
            nome="Nísia Verônica Trindade Lima"
            cargo="Ministra da Saúde"
          />
        </SwiperSlide>

        <SwiperSlide>
          <CardConvidados
            image={MinistraMaria}
            title="Maria Elizabeth Guimarães Teixeira Rocha"
            nome="Maria Elizabeth Guimarães Teixeira Rocha"
            cargo="Ministra do Superior Tribunal Militar"
          />
        </SwiperSlide>

      </Swiper>
    </>
  );
};

export default CarrosselConvidados;
